module.exports = __webpack_public_path__ + "img/treasarytobranch.fw.9c7a32f2.png";